import React, { useState, useEffect } from 'react';
import styles from './Training.module.css';

const Training = () => {
    const [items, setItems] = useState([]);
    const [settings, setSettings] = useState({
        title: 'Обучение',
        showTitle: true,
        columns: 3,
        gap: 30
    });
    const [loading, setLoading] = useState(true);
    const [selectedItem, setSelectedItem] = useState(null);
    const [consent, setConsent] = useState(false);
    const [date, setDate] = useState('');

    // Telegram ссылка (замените на вашу)
    const TELEGRAM_LINK = "https://t.me/lozovskaya_tanya";

    useEffect(() => {
        loadTraining();
    }, []);

    const loadTraining = async () => {
        try {
            const [itemsRes, settingsRes] = await Promise.all([
                fetch('/api/content/training?field=items'),
                fetch('/api/content/training?field=settings')
            ]);

            const itemsData = await itemsRes.json();
            const settingsData = await settingsRes.json();

            let allItems = itemsData.data || [];
            allItems.sort((a, b) => (a.order || 0) - (b.order || 0));

            setItems(allItems.filter(i => i.visible));
            setSettings(settingsData.data || { title: 'Обучение', showTitle: true, columns: 3, gap: 30 });
        } catch (error) {
            console.error('Ошибка загрузки обучения:', error);
        } finally {
            setLoading(false);
        }
    };

    const formatPrice = (item) => {
        if (item.isRange) {
            return `${item.priceMin?.toLocaleString()} - ${item.priceMax?.toLocaleString()} ₽`;
        }
        return `${item.price?.toLocaleString()} ₽`;
    };

    const openModal = (item) => {
        setSelectedItem(item);
        setConsent(false);
        setDate('');
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedItem(null);
        document.body.style.overflow = 'auto';
    };

    const handleSubmit = () => {
        if (!consent) return;

        // Формируем сообщение
        const dateText = date ? ` на ${date}` : '';
        const messageText = `Добрый день, меня интересует курс "${selectedItem.name}"${dateText}`;
        const encodedMessage = encodeURIComponent(messageText);

        // Убираем @ из ника если есть
        const telegramLink = TELEGRAM_LINK.replace('@', '');

        // Открываем Telegram
        window.open(`${telegramLink}?text=${encodedMessage}`, '_blank');

        closeModal();
    };

    if (loading || items.length === 0) return null;

    return (
        <>
            <section id="training" className={styles.training}>
                <div className={styles.container}>
                    {settings.showTitle && (
                        <h2 className={styles.title}>{settings.title}</h2>
                    )}

                    <div
                        className={styles.grid}
                        style={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${settings.columns || 3}, 1fr)`,
                            gap: `${settings.gap || 30}px`
                        }}
                    >
                        {items.map((item) => (
                            <div key={item.id} className={styles.card}>
                                <div className={styles.imageWrapper}>
                                    {item.imageUrl ? (
                                        <img
                                            src={item.imageUrl}
                                            alt={item.name}
                                            className={styles.image}
                                        />
                                    ) : (
                                        <div className={styles.placeholder}>📚</div>
                                    )}
                                </div>
                                <h3 className={styles.name}>{item.name}</h3>
                                <div className={styles.duration}>⏱️ {item.duration}</div>
                                <div className={styles.price}>{formatPrice(item)}</div>
                                <button
                                    className={styles.bookBtn}
                                    onClick={() => openModal(item)}
                                >
                                    Записаться на курс
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Модальное окно */}
            {selectedItem && (
                <div className={styles.modalOverlay} onClick={closeModal}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <button className={styles.closeBtn} onClick={closeModal}>✕</button>

                        <div className={styles.modalBody}>
                            <div className={styles.modalImage}>
                                {selectedItem.imageUrl ? (
                                    <img src={selectedItem.imageUrl} alt={selectedItem.name} />
                                ) : (
                                    <div className={styles.modalPlaceholder}>📚</div>
                                )}
                            </div>

                            <div className={styles.modalInfo}>
                                <h3>{selectedItem.name}</h3>
                                <div className={styles.modalDuration}>⏱️ {selectedItem.duration}</div>
                                <div className={styles.modalPrice}>{formatPrice(selectedItem)}</div>
                                <div className={styles.modalDescription}>{selectedItem.description}</div>

                                <div className={styles.modalForm}>
                                    <input
                                        type="date"
                                        value={date}
                                        onChange={(e) => setDate(e.target.value)}
                                        className={styles.formInput}
                                        min={new Date().toISOString().split('T')[0]}
                                        placeholder="Выберите дату"
                                    />

                                    <label className={styles.checkboxLabel}>
                                        <input
                                            type="checkbox"
                                            checked={consent}
                                            onChange={(e) => setConsent(e.target.checked)}
                                        />
                                        <span>Продолжая, вы соглашаетесь с обработкой персональных данных</span>
                                    </label>

                                    <button
                                        className={styles.submitBtn}
                                        disabled={!consent}
                                        onClick={handleSubmit}
                                    >
                                        Отправить заявку
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Training;